import React, { useState, useRef } from "react";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";

import { Grid, Slider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tabContainer: {
        padding: theme.spacing(2),
    },
    popoverPaper: {
        width: "100%",
        maxWidth: 350,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            maxWidth: 270,
        },
    },
    noShadow: {
        boxShadow: "none !important",
    },
    icons: {
        color: "#fff",
    },
    customBadge: {
        backgroundColor: "#f44336",
        color: "#fff",
    },
}));

const NotificationsVolume = ({ volume, setVolume }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isRtl = theme.direction === 'rtl';

    const anchorEl = useRef();
    const [isOpen, setIsOpen] = useState(false);
    
    // Ensure volume is always a number
    const numericVolume = typeof volume === 'number' ? volume : parseFloat(volume) || 1;

    const handleClick = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleClickAway = () => {
        setIsOpen(false);
    };

    const handleVolumeChange = (e, value) => {
        const numValue = parseFloat(value);
        setVolume(numValue);
        localStorage.setItem("volume", numValue.toString());
    };

    return (
        <>
            <IconButton
                className={classes.icons}
                onClick={handleClick}
                ref={anchorEl}
                aria-label="Open Notifications"
            >
                <VolumeUpIcon  style={{ color: "white" }}/>
            </IconButton>
            <Popover
                disableScrollLock
                open={isOpen}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                classes={{ paper: classes.popoverPaper }}
                onClose={handleClickAway}
            >
                <List dense className={classes.tabContainer}>
                    <Grid container spacing={2}>
                        <Grid item>
                            {isRtl ? <VolumeUpIcon /> : <VolumeDownIcon />}
                        </Grid>
                        <Grid item xs>
                            <Slider
                                value={numericVolume}
                                aria-labelledby="continuous-slider"
                                step={0.1}
                                min={0}
                                max={1}
                                onChange={handleVolumeChange}
                            />
                        </Grid>
                        <Grid item>
                            {isRtl ? <VolumeDownIcon /> : <VolumeUpIcon />}
                        </Grid>
                    </Grid>
                </List>
            </Popover>
        </>
    );
};

// Mounted permanently in the AppBar — memo keeps it out of shell re-renders.
export default React.memo(NotificationsVolume);
